// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, [821,2245], () => (__webpack_require__(2632)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
